import styled from "styled-components";
import { tokens, palette } from "@plataforma/components";

export const Logout = styled.button`
  ${tokens.font.s};

  display: block;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  margin: 0 0 ${tokens.spacing.xs};
  font-family: inherit;

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
    font-weight: ${tokens.font.weight.semibold};
    color: ${palette['color-brand-primary']};
  }
`;